import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { SolanaWalletProvider } from './contexts/SolanaWalletProvider';
import Header from './components/Header';
import Home from './pages/Home';
import Play from './pages/Play';
import MyTickets from './pages/MyTickets';
import Results from './pages/Results';
import LiveDraw from './pages/LiveDraw';
import Admin from './pages/Admin';
import axios from 'axios';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function AppContent() {
  const [network, setNetwork] = useState('devnet');

  useEffect(() => {
    // Fetch network setting from backend
    const fetchNetwork = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/settings`);
        setNetwork(response.data.network || 'devnet');
      } catch (error) {
        console.error('Error fetching network:', error);
      }
    };
    fetchNetwork();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchNetwork, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SolanaWalletProvider network={network}>
      <BrowserRouter>
        <div className="min-h-screen bg-[#020617]">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/play" element={<Play />} />
              <Route path="/my-tickets" element={<MyTickets />} />
              <Route path="/results" element={<Results />} />
              <Route path="/live-draw" element={<LiveDraw />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Toaster 
            position="bottom-right"
            toastOptions={{
              style: {
                background: '#0F172A',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#F8FAFC',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </SolanaWalletProvider>
  );
}

function App() {
  return <AppContent />;
}

export default App;
